import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';

export class Counter extends Component {
  static displayName = Counter.name;

  constructor (props) {
    super(props);
    this.state = { currentCount: 0 };
      this.incrementCounter = this.incrementCounter.bind(this);
      
      fetch('User/Login');
  }

  incrementCounter () {
    this.setState({
      currentCount: this.state.currentCount + 1
    });


      fetch('Payment/ChargeBalanceByCard');
      //this.props.history.push('/Home');
    //fetch('User/Login');
  }

  render () {
    return (
      <div>
        <h1>Counter</h1>

        <p>This is a simple example of a React component.</p>

        <p>Current count: <strong>{this.state.currentCount}</strong></p>

        <button className="btn btn-primary" onClick={this.incrementCounter}>Increment</button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Counter.js